import React from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Fixed,
  Modal as RebassModal,
  Heading,
  Close,
  Flex,
  Text,
} from 'rebass'
import { themeGet } from 'styled-system'
import styled from 'styled-components'

const Success = styled(RebassModal)`
  box-shadow: 0 0 0 60vmax rgba(0, 0, 0, 0.5),
    0 0 32px ${themeGet(`colors.red`)};
`

const Modal = ({ close }) => (
  <Box>
    <Fixed top={0} right={0} bottom={0} left={0} onClick={close} />
    <Success borderRadius={0} width={[250, 480]}>
      <Flex justifyContent="space-between">
        <Heading>Success</Heading>
        <Close onClick={close} />
      </Flex>
      <Flex alignItems="center" py={3}>
        <Text>Your message has been submitted.</Text>
      </Flex>
    </Success>
  </Box>
)

Modal.propTypes = {
  close: PropTypes.func,
}

export default Modal



// WEBPACK FOOTER //
// ./src/containers/Contact/Modal.js